import { ChangeDetectionStrategy, Component, inject, input, signal, ViewEncapsulation } from '@angular/core';
import { SVGAwesomeDirective } from '@pixelgenau/ngx-svg-awesome/browser';
import { MatelsoService } from 'libs/ng-common-lib/src/services/matelso.service';
import { derivedAsync } from 'libs/ng-common-lib/src/utilities/derived-async';
import { firstValueFrom } from 'rxjs';
import { M010C080PhoneRibbonStyleToken } from './m010-c080-phone-ribbon.style';

@Component({
    selector: 'wholesale-m010-c080-phone-ribbon',
    imports: [SVGAwesomeDirective],
    templateUrl: './m010-c080-phone-ribbon.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M010C080PhoneRibbonComponent {
    elStyle = inject(M010C080PhoneRibbonStyleToken);
    matelsoService = inject(MatelsoService, { optional: true });

    desktopText = input<string>();
    phoneNumber = input<string>();

    contentVisible = signal(false);
    phoneNumberService = derivedAsync(() => {
        const phoneNumber = this.phoneNumber();
        if (phoneNumber && this.matelsoService) return firstValueFrom(this.matelsoService.getPhoneNumber$(phoneNumber));

        return undefined;
    });

    toggleVisibility() {
        this.contentVisible.set(!this.contentVisible());
    }
}
